import { fetch } from "./request/fetch";


/** 获取资产信息  */
export async function getNoticeInfo() {
    return fetch(
        'queryNotice'
    )
}
